module.exports = __webpack_public_path__ + "static/media/03-california.c127d38e.jpg";